import { Navigate, Route, Routes } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import type { ReactNode } from 'react';
import { meState } from './state.js';
import { RikuzPage } from './pages/RikuzPage.js';
import { PrintPage } from './pages/PrintPage.js';
import { AdminUsersPage } from './pages/AdminUsersPage.js';
import { AdminPage } from './pages/AdminPage.js';

/** UI-side gate for admin routes. Defense in depth only — every /api/admin/*
 * endpoint is ALSO uber-gated server-side (requireUber); this stops viewers
 * from even seeing the admin shells. */
function UberOnly({ children }: { children: ReactNode }) {
  const me = useRecoilValue(meState);
  if (me?.role !== 'uber') return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function Router() {
  return (
    <Routes>
      <Route path="/" element={<RikuzPage />} />
      <Route path="/print" element={<PrintPage />} />
      <Route path="/admin/users" element={<UberOnly><AdminUsersPage /></UberOnly>} />
      {/* The two old admin pages are now sections of one area; their links live
          on in bookmarks and in a PR body or two, so they still land somewhere. */}
      <Route path="/admin/ingest" element={<Navigate to="/admin/monthly" replace />} />
      <Route path="/admin/data" element={<Navigate to="/admin/clients" replace />} />
      <Route path="/admin" element={<Navigate to="/admin/monthly" replace />} />
      <Route path="/admin/:section" element={<UberOnly><AdminPage /></UberOnly>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
